import { createElementBlock as t, openBlock as o, createElementVNode as n } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
};
function l(s, e) {
  return o(), t("svg", r, [...e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      d: "M28.776 8.248a3.34 3.34 0 0 0-2.357-2.357C24.339 5.333 16 5.333 16 5.333s-8.339 0-10.419.558a3.34 3.34 0 0 0-2.357 2.357C2.667 10.328 2.667 16 2.667 16s0 5.672.557 7.752a3.34 3.34 0 0 0 2.357 2.357c2.08.558 10.419.558 10.419.558s8.339 0 10.419-.558a3.34 3.34 0 0 0 2.357-2.357c.557-2.08.557-7.752.557-7.752s0-5.672-.557-7.752m-15.443 12.37v-9.237l8 4.619z"
    }, null, -1)
  ])]);
}
const a = { render: l };
export {
  a as default,
  l as render
};
